/** Shared numeric layout for form controls (uiLab kit). */
export const formFieldControlMinHeightPx = 44;
/** Figma `Outline Thickness`. Unchanged — see "Deviations from the Figma". */
export const formFieldBorderWidthPx = 1.5;
/** Resting border tint over `colors.medium` (#607F90) — Figma `Outline Default` (ERS-61). */
export const formFieldBorderOpacity = 0.15;
